/* ============================================================
   BRONZ'D THEME — bronzd.js
   UI enhancements only. All cart/checkout logic uses Shopify native.
   ============================================================ */
document.addEventListener('DOMContentLoaded', function () {

  /* ── COUNTDOWN TIMER ── */
  var totalSecs = parseInt(localStorage.getItem('bzTimer') || '') || (8 * 3600 + 47 * 60 + 32);
  function bzTick() {
    if (totalSecs <= 0) totalSecs = 8 * 3600 + 47 * 60 + 32;
    totalSecs--;
    localStorage.setItem('bzTimer', totalSecs);
    var h = Math.floor(totalSecs / 3600);
    var m = Math.floor((totalSecs % 3600) / 60);
    var s = totalSecs % 60;
    var hEl = document.getElementById('bzHrs');
    var mEl = document.getElementById('bzMins');
    var sEl = document.getElementById('bzSecs');
    if (hEl) hEl.textContent = String(h).padStart(2, '0');
    if (mEl) mEl.textContent = String(m).padStart(2, '0');
    if (sEl) sEl.textContent = String(s).padStart(2, '0');
  }
  if (document.getElementById('bzHrs')) { bzTick(); setInterval(bzTick, 1000); }

  /* ── STOCK COUNTER ── */
  var stock = parseInt(localStorage.getItem('bzStock') || '23');
  var stockEl = document.getElementById('bzStock');
  if (stockEl) {
    stockEl.textContent = stock;
    setInterval(function () {
      if (Math.random() < 0.15 && stock > 8) {
        stock--;
        localStorage.setItem('bzStock', stock);
        stockEl.textContent = stock;
      }
    }, 14000);
  }

  /* ── FAQ ACCORDION ── */
  document.querySelectorAll('.bz-faq-q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.parentElement;
      var isOpen = item.classList.contains('bz-open');
      document.querySelectorAll('.bz-faq-item').forEach(function (i) { i.classList.remove('bz-open'); });
      if (!isOpen) item.classList.add('bz-open');
    });
  });
/* ── PRODUCT GALLERY THUMBNAILS ── */
  document.querySelectorAll('.bz-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('.bz-product-main-img');
      if (main) {
        main.src = thumb.dataset.full || thumb.src;
        document.querySelectorAll('.bz-thumb').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      }
    });
  });
  

  /* ── SCROLL REVEAL ── */
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('bz-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.bz-reveal').forEach(function (el) { obs.observe(el); });
  } else {
    document.querySelectorAll('.bz-reveal').forEach(function (el) { el.classList.add('bz-visible'); });
  }

  /* ── MOBILE NAV TOGGLE ── */
  var navToggle = document.getElementById('bzNavToggle');
  var navMobile = document.getElementById('bzNavMobile');
  if (navToggle && navMobile) {
    navToggle.addEventListener('click', function () {
      navMobile.classList.toggle('bz-nav-mobile-open');
    });
  }

  /* ── CART COUNT UPDATE (reads Shopify cart API) ── */
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var countEl = document.getElementById('bzCartCount');
      if (countEl && cart.item_count > 0) countEl.textContent = cart.item_count;
    })
    .catch(function () {});
});
